<template>
  <dropdown-input
    :options="options"
    :position="position"
    @select="handleSelect"
  >
    <button-input>
      <font-awesome-icon icon="cog" />
      <font-awesome-icon icon="angle-down" />
    </button-input>

    <div
      :class="classes"
      class="nav-bar-entry--dropdown"
    >
      <font-awesome-icon
        v-if="hasIcon"
        :icon="icon"
        class="nav-bar-entry__icon"
      />
      <span class="nav-bar-entry__label visible-md">
        {{ label }}
      </span>
    </div>
  </dropdown-input>
</template>

<script>
import NavBarEntryMixin from '@/mixins/ui/NavBarEntry'
import FormMixin from '@/mixins/forms/Form'

export default {
  name: 'NavBarDropdown',
  mixins: [NavBarEntryMixin, FormMixin],
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleSelect (selected) {
      this.$emit('select', selected)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/NavBarDropdown.vue